import { NgForm } from '@angular/forms';
import { Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, } from '@angular/material/dialog';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { PostulacionesService } from '../../services/postulaciones/postulaciones.service';
import Swal from 'sweetalert2';                                                                         
import { MantenedorConvenioColaboracionService } from 'src/app/services/mantenedor-convenio-colaboracion/mantenedor-convenio-colaboracion.service';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';
import { ChangeDetectionStrategy } from '@angular/core';
import * as FileSaver from 'file-saver';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

export interface DialogData {
   
    regiones: any,
    rut: any,
    dv: any,
    nombre: any,
    fechaEf: any,
    region: any,
    archivo: File
}
declare const Rut: any;
@Component({
    selector: 'dialog-overview-example-dialog',
    templateUrl: '../../pages/mantenedor-convenio-colaboracion/crear-convenio-colaboracion.component.html',
    styleUrls: ['../../pages/mantenedor-convenio-colaboracion/mantenedor-convenio-colaboracion.component.css']

})
export class DialogCrearConvenioColaboracion {
    regiones: any   
    categorias: any
    archivo: File
    convenioColaboracion: any = {
        id: '',
        rut: '',
        dv: '',
        nombre: '',
        razonSocial: '',     
        idRegion: 0,
        regiones: '',
        fechaInicio: '',
        fechaFin: '',
        descripcion: '',
        archivo: [],
        archivoTest: null,
        

    }
    constructor(public dialogRef: MatDialogRef<DialogCrearConvenioColaboracion>,
        private dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: DialogData,
        private mantenedorConvenioColaboracionService: MantenedorConvenioColaboracionService) { }

    ngOnInit(): void { this.loadData() }

    loadData() {
        let vm = this
        this.mantenedorConvenioColaboracionService.traeRegiones().then
            (regiones => { vm.regiones = regiones })
 
    }
  
    onCancelarClick(): void { this.dialogRef.close() }

    openAlertDialog(mensaje: string, clase: string) {
        this.dialog.open(AlertDialogComponent, {
            data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
        })
    }

  
   
    onCrearconvenioColaboracionClick(form: NgForm) {
       let vm = this;
       if(!this.convenioColaboracion.rut){
        this.openAlertDialog('Antes de crear el convenio debe escribir el rut.', 'btn-danger')
        return false
       }
       if(!this.convenioColaboracion.nombre){
        this.openAlertDialog('Antes de crear el convenio debe escribir un nombre.', 'btn-danger')
        return false
       }
       if(!this.convenioColaboracion.fechaInicio){
        this.openAlertDialog('Antes de crear el convenio debe seleccionar una fecha Inicio.', 'btn-danger')
        return false
       }
       if(!this.convenioColaboracion.fechaFin){
        this.openAlertDialog('Antes de crear el convenio debe seleccionar una fecha fin.', 'btn-danger')
        return false
       }
       if(!this.convenioColaboracion.archivo[0]){
        this.openAlertDialog('Antes de crear el convenio debe cargar un archivo adjunto.', 'btn-danger')
        return false
       }
       if(!this.convenioColaboracion.idRegion  || this.convenioColaboracion.idRegion ==0){
        this.openAlertDialog('Antes de crear el convenio debe escribir una región.', 'btn-danger')
        return false
       }

       if(!this.convenioColaboracion.descripcion){
        this.openAlertDialog('Antes de crear el convenio debe agregar una descripción.', 'btn-danger')
        return false
       }
      

       let fechaInicioC = this.convenioColaboracion.fechaInicio.split('-')[2] + '-' + 
       this.convenioColaboracion.fechaInicio.split('-')[1] + '-' + 
       this.convenioColaboracion.fechaInicio.split('-')[0]
     
        let fechaFinC = this.convenioColaboracion.fechaFin.split('-')[2] + '-' + 
        this.convenioColaboracion.fechaFin.split('-')[1] + '-' + 
        this.convenioColaboracion.fechaFin.split('-')[0]
        
        let sizeArchivos = 0;
        sizeArchivos = this.convenioColaboracion.archivo[0].size
      
      
        const dialogRef = this.dialog.open(ConfirmationDialog,
            {
                data: { message: '¿Esta seguro de Ingresar un nuevo convenio de colaboración?', buttonText: { ok: 'Si', cancel: 'No' } }
            })
        dialogRef.afterClosed().subscribe((confirmed: boolean) => {
            if (confirmed) {
                Swal.fire({
                    allowOutsideClick: false,
                    icon: 'info',
                    text: 'Cargando...'
                });
                Swal.showLoading();
                this.mantenedorConvenioColaboracionService.ingresarConvenioColaboracion(localStorage.getItem("idUsuario"), this.convenioColaboracion,fechaInicioC,fechaFinC).
                    then(
                        () => {

                            this.openAlertDialog('El convenio de colaboración fue creado exitosamente.', 'btn-success');
                            form.reset();
                            Swal.close();
                            this.dialogRef.close();
                            
                        }
                    )
                    .catch(error => {
                        console.log(error)
                        Swal.close();
                        this.openAlertDialog('Ha ocurrido un error al ingresar un convenio de colaboración.', 'btn-danger')
                    })
            }
        })
    }
    /*
    sumaArchivo() {
        if (this.cantidadArchivos <= 5) {
    
          this.cantidadArchivos = this.cantidadArchivos + 1
        }
      }
    */
      seleccionaArchivo(event: any)
      {
        let numero= 0;
          if(event.target.files.length > 0)
          {
              console.log(event.target.files[0].type)
  
              let vm = this
              let reader = new FileReader()
              this.convenioColaboracion.archivo[numero] = { url: "", archivo: reader.result, extension: event.target.files[0].type, size:event.target.files[0].size }
              reader.readAsDataURL(event.target.files[0])
  
              reader.onload = function() {
                  vm.convenioColaboracion.archivo[numero] = { url: "", archivo: reader.result, extension: event.target.files[0].type, size:event.target.files[0].size }
  
                  console.log(vm.convenioColaboracion.archivo)
              }
          }
      }

    csvInputChange(fileInputEvent: any) {

        this.convenioColaboracion.archivo = fileInputEvent.target.files[0]
    }



}